export default {
  name: "FormalDocumentTemplatePreview",
  props: {
    preview_error: {
      type: String,
      default: "",
    },
    preview_html: {
      type: String,
      default: "",
    },
    preview_loading: {
      type: Boolean,
      default: false,
    },
    template_form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visible_section_count() {
      return (this.template_form?.sections || []).filter(
        (section) => section.is_visible !== false
      ).length;
    },
    preview_frame_key() {
      return [
        this.visible_section_count,
        this.preview_loading ? "loading" : "ready",
        this.preview_html.length,
      ].join("_");
    },
    preview_status_label() {
      if (this.preview_loading && !this.preview_html) {
        return "Rendering";
      }
      if (this.preview_loading) {
        return "Updating";
      }
      return "Live";
    },
  },
};
